// src/components/Home.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';


const EmailVerified: React.FC = () => {
    const location = useLocation();

    const getSuccess = (): boolean => {
        const params = new URLSearchParams(location.search);
        return params.get('success') === 'true';
    };

    const success = getSuccess();

    return (
        <div>
            <div id="content-pane">
                {success && <p>Email verification succeeded. Please log in to continue.</p>}
                {!success && <p>Email verification failed. Please log in to retry.</p>}
            </div>
        </div>
    );
};

export default EmailVerified;
